import React from 'react';
import FooterSC from './footer.styled';
import { BodyText } from '../../typography';
import { FormattedHTMLMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';

const Footer = () => {
  return (
    <FooterSC>
      <BodyText>
        <FormattedHTMLMessage id="footer_copyright" defaultMessage={dlt['footer_copyright']} />
      </BodyText>
    </FooterSC>
  );
};
export default Footer;
